import {
    BanknoteIcon,
    BlocksIcon,
    type ColorTokenKey,
    FeatherIcon,
    FlagIcon,
    type IconType,
    PiggyBankIcon,
} from 'smoothie';

export interface IGoalGroup {
    id: string;
    membershipId: string;
    categoryId: string;
    position: number;
    createdAt: string;
    updatedAt: string | null;
    goalCategory: IGoalCategory;
    goals: IGoal[];
}

export interface IGoalCategory {
    id: string;
    description: GoalCategoryDescription;
    createdAt: string;
    updatedAt: string | null;
}

export interface IGoalAccountLink {
    id: string;
    goalId: string;
    accountId: string;
    provider: string;
    createdAt: string;
    updatedAt: string | null;
}

export interface IGoal {
    id: string;
    goalGroupId: string;
    description: string;
    status: GoalStatus;
    targetAmount?: number | null;
    position: number;
    createdAt: string;
    updatedAt: string | null;
    tasks: IGoalTask[];
    category?: IGoalCategory;
    accountLinks?: IGoalAccountLink[];
}

export enum GoalStatus {
    NOT_STARTED = 'NOT_STARTED',
    IN_PROGRESS = 'IN_PROGRESS',
    COMPLETE = 'COMPLETE',
    DELETED = 'DELETED',
}

export interface IGoalTask {
    id: string;
    goalId: string;
    description: string;
    status: GoalTaskStatus;
    position: number;
    createdAt: string;
    updatedAt: string | null;
}

export enum GoalTaskStatus {
    IN_PROGRESS = 'IN_PROGRESS',
    COMPLETE = 'COMPLETE',
    DELETED = 'DELETED',
}

export enum GoalCategoryDescription {
    FUNDAMENTALS = 'Fundamentals',
    MONEY_MANAGEMENT = 'Money Management',
    BUILDING_WEALTH = 'Building Wealth',
    MILESTONES = 'Milestones',
    LEGACY = 'Legacy',
}

export const GoalColors: Record<GoalCategoryDescription, ColorTokenKey> = {
    [GoalCategoryDescription.FUNDAMENTALS]: '$peach300',
    [GoalCategoryDescription.MONEY_MANAGEMENT]: '$marigold300',
    [GoalCategoryDescription.BUILDING_WEALTH]: '$orchidPink300',
    [GoalCategoryDescription.MILESTONES]: '$green300',
    [GoalCategoryDescription.LEGACY]: '$dropletBlue300',
};

export const GoalSecondaryColors: Record<
    GoalCategoryDescription,
    ColorTokenKey
> = {
    [GoalCategoryDescription.FUNDAMENTALS]: '$peach1200',
    [GoalCategoryDescription.MONEY_MANAGEMENT]: '$marigold1200',
    [GoalCategoryDescription.BUILDING_WEALTH]: '$orchidPink1200',
    [GoalCategoryDescription.MILESTONES]: '$green1200',
    [GoalCategoryDescription.LEGACY]: '$dropletBlue1200',
};

export const GoalIcons: Record<GoalCategoryDescription, IconType> = {
    [GoalCategoryDescription.FUNDAMENTALS]: BlocksIcon,
    [GoalCategoryDescription.MONEY_MANAGEMENT]: BanknoteIcon,
    [GoalCategoryDescription.BUILDING_WEALTH]: PiggyBankIcon,
    [GoalCategoryDescription.MILESTONES]: FlagIcon,
    [GoalCategoryDescription.LEGACY]: FeatherIcon,
};

export enum GoalTabType {
    ACTIVE = 'active',
    COMPLETE = 'complete',
}

export enum GoalCardContext {
    LIST = 'list',
    COMPLETED_SHEET = 'completedSheet',
    HOME = 'home',
}
